import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@mui/material';

// AC-13 — no existing analog to compose from; a plain Alert+Button. Non-alarming
// ("informative" blue, not "warning" amber) — the shown window was narrowed, not an error.
const WindowClampedBanner = ({ onLoadEarlier }) => (
  <Alert
    severity='info'
    sx={{ mt: 2, mb: 2 }}
    action={
      <Button color='inherit' size='small' onClick={onLoadEarlier}>
        Load earlier records
      </Button>
    }
  >
    The shown window was narrowed — older records may exist beyond it.
  </Alert>
);

WindowClampedBanner.propTypes = {
  onLoadEarlier: PropTypes.func.isRequired,
};

export default React.memo(WindowClampedBanner);
